import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { OutlinedInput, Alert, AlertTitle, Paper, Stack } from '@mui/material';
import RssFeedIcon from '@mui/icons-material/RssFeed';
import { CheckCircle, Upload } from '@mui/icons-material';
import * as ETVConstants from '../ETVConstants';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVPage from '../tools/ETVPage';

class RSSCreator extends React.Component {
  constructor(props) {
    super(props);
    this.selectedScreens = this.selectedScreens.bind(this);
    this.closeScreenSelection = this.closeScreenSelection.bind(this);
  }

  state = {
    rss_title: '',
    rss_url: '',
    checking_rss: false,
    test_title_0: '',
    test_desc_0: '',
    test_title_1: '',
    test_desc_1: '',
    test_result: '', // '', 'ok', 'failed'
    channel: '0',
    selected_screens: [],
    // ui
    window: '',
    info_title: '',
    info_message: '',
    info_type: 'info',
    show_overlay: false,
  };

  selectedScreens(screenIDs) {
    this.showWindow('select_screens_div', false);
    this.setState({ selected_screens: screenIDs });
  }

  closeScreenSelection() {
    this.showWindow('select_screens_div', false);
  }

  showWindow(divID, show) {
    this.setState({ show_overlay: show });
    show ? this.setState({ window: divID }) : this.setState({ window: '' });
  }

  showInfoMessage(msg, type = 'info') {
    this.setState({ window: 'message_div', info_message: msg, info_type: type });
  }

  closeInfoMessage() {
    this.setState({ window: '', show_overlay: false, info_title: '', info_message: '', info_type: 'info' });
  }

  getFilename() {
    const m = new Date();
    const dateString = '' + m.getUTCFullYear() + (m.getUTCMonth() + 1) + m.getUTCDate() + m.getUTCHours() + m.getUTCMinutes() + m.getUTCSeconds();
    return dateString + '_rss.html';
  }

  saveRSS() {
    this.showInfoMessage(ETVConstants.trans('uploading...'), 'progress');
    let url = ETVConstants.getServerBase() + '/template_servlet?action=create_and_save_template&user_id=' + this.props.user_id;
    url += '&template_path=templates/rss/rss_template.html';
    url += '&filename=' + this.getFilename();
    url += '&thumbnail=' + encodeURIComponent('https://elevatortvfrontend.uc.r.appspot.com/thumbnails/thumb_rss.jpg');
    url += '&showing_time=20';
    url += '&param_0.name=@@rss_url@@&param_0.value=' + encodeURIComponent(this.createRSSURL(this.state.rss_url));
    url += '&param_1.name=@@rss_title@@&param_1.value=' + encodeURIComponent(this.state.rss_title);
    url += '&desc=' + encodeURIComponent(this.state.rss_title);

    if (this.state.selected_screens && this.state.selected_screens.length > 0) {
      url += '&channel=' + this.state.channel;
      for (let i = 0; i < this.state.selected_screens.length; i++) {
        url += '&device_id=' + this.state.selected_screens[i];
      }
    }

    const accessToken = localStorage.getItem('etv.access_token');
    const reqUserID = localStorage.getItem('etv.user_id');
    fetch(url, { headers: { user_id: reqUserID, access_token: accessToken } })
      .then((res) => res.json())
      .then(
        () => {
          this.setState({
            rss_title: '',
            rss_url: '',
            checking_rss: false,
            test_title_0: '',
            test_desc_0: '',
            test_title_1: '',
            test_desc_1: '',
            test_result: '',
            channel: '0',
            selected_screens: [],
          });
          this.showInfoMessage(ETVConstants.trans('the_content_was_stored_in_your_library'), 'success');
        },
        (error) => {
          this.showInfoMessage('error happened: ' + error, 'error');
          this.setState({
            rss_title: '',
            rss_url: '',
            checking_rss: false,
            test_title_0: '',
            test_desc_0: '',
            test_title_1: '',
            test_desc_1: '',
            test_result: '',
            channel: '0',
            selected_screens: [],
          });
        }
      );
  }

  createRSSURL(url) {
    return ETVConstants.getServerBase() + '/proxy?url=' + encodeURIComponent(url);
  }

  testRSS() {
    this.setState({ checking_rss: true, test_result: '' });
    const url = this.createRSSURL(this.state.rss_url);
    fetch(url)
      .then((response) => response.text())
      .then(
        (result) => {
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(result, 'text/xml');
          const res = this.parseRSS(xmlDoc);
          this.receiveData(res);
          this.setState({ checking_rss: false });
        },
        (error) => {
          this.setState({ checking_rss: false });
          this.showInfoMessage('error happened: ' + error, 'error');
        }
      );
  }

  removeTags(content) {
    return content ? content.replace(/(<([^>]+)>)/gi, '') : '';
  }

  parseRSS(xmlDoc) {
    const elems = xmlDoc.getElementsByTagName('item');
    const result = [];
    for (let i = 0; i < 5; i++) {
      try {
        const elem = elems[i];
        const childNodes = elem?.childNodes;
        const o = {};
        for (let k = 0; childNodes && k < childNodes.length; k++) {
          if (childNodes[k].nodeName === 'title') {
            o.title = this.removeTags(childNodes[k].childNodes[0]?.nodeValue);
          } else if (childNodes[k].nodeName === 'description') {
            o.desc = this.removeTags(childNodes[k].childNodes[0]?.nodeValue);
          } else if (childNodes[k].nodeName === 'pubDate') {
            const pDate = new Date(childNodes[k].childNodes[0]?.nodeValue).toLocaleString();
            o.pubDate = pDate;
          } else if (childNodes[k].nodeName === 'link') {
            o.link = childNodes[k].childNodes[0]?.nodeValue;
          }
        }
        result.push(o);
      } catch (err) {}
    }
    return result;
  }

  receiveData(objects) {
    if (objects && objects.length > 0 && objects[0].title && objects[0].title.length > 0) {
      this.setState({ test_result: 'ok' });
      this.setState({ test_title_0: objects[0].title, test_desc_0: objects[0].desc });
      this.setState({ test_title_1: objects[1]?.title || '', test_desc_1: objects[1]?.desc || '' });
    } else {
      this.setState({ test_result: 'failed' });
    }
  }

  isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === 'http:' || url.protocol === 'https:';
  }

  renderPreview() {
    const { test_result, test_title_0, test_desc_0, test_title_1, test_desc_1 } = this.state;
    if (test_result === 'failed') {
      return (
        <Alert severity="error" sx={{ mt: 2 }}>
          <AlertTitle>{ETVConstants.trans('error') || 'Error'}</AlertTitle>
          {ETVConstants.trans('sorry_failed_to_load_rss')}
        </Alert>
      );
    }
    if (test_result === 'ok') {
      return (
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Alert icon={<CheckCircle />} severity="success">
            <AlertTitle>{ETVConstants.trans('success')}</AlertTitle>
            {ETVConstants.trans('feed_loaded_successfully') || 'Feed loaded successfully'}
          </Alert>
          <Paper variant="outlined" sx={{ p: 2 }}>
            <Typography variant="subtitle2" sx={{ bgcolor: 'action.hover', p: 1, borderRadius: 1, mb: 1 }}>
              {test_title_0}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {test_desc_0}
            </Typography>
          </Paper>
          {test_title_1 && (
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle2" sx={{ bgcolor: 'action.hover', p: 1, borderRadius: 1, mb: 1 }}>
                {test_title_1}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {test_desc_1}
              </Typography>
            </Paper>
          )}
        </Stack>
      );
    }
    return null;
  }

  render() {
    const selectedCount = this.state.selected_screens?.length || 0;
    const canValidate = !this.state.checking_rss && this.isValidHttpUrl(this.state.rss_url);
    const uploading = this.state.window === 'message_div' && this.state.info_type === 'progress';

    return (
      <ETVPage
        width="standard"
        icon={<RssFeedIcon fontSize="large" />}
        title={ETVConstants.trans('rss_feeds')}
        loading={this.state.checking_rss || uploading}
        bottomActions={
          <ETVActionButton
            action="send"
            label={ETVConstants.trans('upload')}
            loadingLabel={ETVConstants.trans('uploading...')}
            loading={uploading}
            disabled={this.state.test_result !== 'ok'}
            startIcon={<Upload />}
            onClick={() => this.saveRSS()}
          />
        }
      >
        <Paper variant="outlined" sx={{p:{xs:2,md:3},borderRadius:3}}>
            <Stack spacing={2.5}>
              <TextField
                required
                label={ETVConstants.trans('title')}
                inputProps={{ maxLength: 50 }}
                fullWidth
                disabled={this.state.checking_rss}
                value={this.state.rss_title}
                onChange={(e) => this.setState({ rss_title: e.target.value })}
              />
              <TextField
                required
                label={ETVConstants.trans('rss_url')}
                inputProps={{ maxLength: 200 }}
                fullWidth
                disabled={this.state.checking_rss}
                value={this.state.rss_url}
                onChange={(e) => this.setState({ rss_url: e.target.value })}
                error={this.state.rss_url.length > 0 && !this.isValidHttpUrl(this.state.rss_url)}
                helperText={
                  this.state.rss_url.length > 0 && !this.isValidHttpUrl(this.state.rss_url)
                    ? ETVConstants.trans('invalid_url') || 'Invalid URL'
                    : ' '
                }
              />
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
                <ETVActionButton
                  action="update"
                  label={ETVConstants.trans('validate')}
                  loading={this.state.checking_rss}
                  disabled={!canValidate}
                  startIcon={<CheckCircle />}
                  onClick={() => this.testRSS()}
                />
              </Stack>

              <Divider />

              {this.renderPreview()}

              <Divider />

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }}>
                <Button variant="outlined" onClick={() => this.showWindow('select_screens_div', true)}>
                  {ETVConstants.trans('select_screens')} ({selectedCount})
                </Button>
                <FormControl sx={{ minWidth: 220 }}>
                  <InputLabel id="channel_id">{ETVConstants.trans('channel')}</InputLabel>
                  <Select
                    labelId="channel_id"
                    id="channel_id"
                    input={<OutlinedInput label={ETVConstants.trans('channel')} />}
                    value={this.state.channel}
                    onChange={(e) => this.setState({ channel: e.target.value })}>
                    <MenuItem value={'0'}>Channel 0</MenuItem>
                    <MenuItem value={'1'}>Channel 1</MenuItem>
                    <MenuItem value={'2'}>Channel 2</MenuItem>
                    <MenuItem value={'3'}>Channel 3</MenuItem>
                    <MenuItem value={'4'}>Channel 4</MenuItem>
                  </Select>
                </FormControl>
              </Stack>
            </Stack>
        </Paper>

        {/* Screen selector overlay */}
        <div id="select_screens_div" style={{ display: this.state.window === 'select_screens_div' ? 'block' : 'none' }}>
          <SelectAvailableScreensNew
            isOpen={this.state.window === 'select_screens_div'}
            user_id={this.props.user_id}
            closeHook={this.closeScreenSelection}
            selectedScreens={this.selectedScreens}
            selected={this.state.selected_screens ? this.state.selected_screens : []}
          />
        </div>

        <ETVMessagePopup
          open={this.state.window === 'message_div'}
          onClose={() => this.closeInfoMessage()}
          type={this.state.info_type}
          title={this.state.info_title}
          message={this.state.info_message}
          closeLabel={ETVConstants.trans('close')}
          allowClose={!uploading}
        />
      </ETVPage>
    );
  }
}

export default RSSCreator;
